import { Component, Mixins, Ref, Vue } from 'vue-property-decorator';

import {
  FindTravelAgentBlockViewModel,
  SearchModel,
  names,
  SearchResultText,
} from './FindTravelAgentModule.types';
import { getComponentProps } from '@/utils/vueUtils';
import { searchAgents } from '@/modules/FindTravelAgentModule/FindTravelAgentModule.api';
import vSelect from 'vue-select';
import SearchResultsGrid from '@/components/SearchResultsGrid/SearchResultsGrid.vue';
import SearchResultTravelAgent from '@/common/interfaces/modules/SearchResultTravelAgent';
import TextRow from '@/forms/FormElements/Rows/TextRow/TextRow.vue';
import FormValidationMixin from '@/forms/FormElements/Mixins/FormValidationMixin';
import getValidation from './FindTravelAgentModule.validations';
import Message from '@/forms/Validations/Message';
import { fixDropdownAudioEye } from '@/utils/domUtils';

const { validations, model, messages } = getValidation();

@Component({
  validations,
  props: getComponentProps<FindTravelAgentBlockViewModel>({
    SortingOptions: [{ Text: 'Relevancy', Value: '' }],
    Radiuses: [
      { Text: '5 miles', Value: '5' },
      { Text: '10 miles', Value: '10' },
    ],
  }),
  components: {
    vSelect,
    SearchResultsGrid,
    TextRow,
  },
})
export default class FindTravelAgentModule extends Mixins(FormValidationMixin) {
  names = names;

  model: SearchModel = model;

  messages: Message[] = messages;

  initialSearchModel: SearchModel = {
    Zip: '',
    Distance: 5,
    IsCanadian: false,
    Page: -1,
    PageSize: 10,
  };

  searchTexts: SearchResultText = {
    Result: 'travel agents match your criteria',
    NotFound: "We couldn't find any travel agents near you. Please contact us directly for more information."
  }

  @Ref('radius') readonly radius: HTMLElement;

  get searchModel() {
    return { ...this.initialSearchModel, ...this.model };
  }
  travelAgents: SearchResultTravelAgent[] = null;

  updateRadius(value) {
    this.initialSearchModel.Distance = value.Value;
  }

  async searchAgent() {
    this.getResult(false);
  }

  async searchCanadianAgent() {
    this.getResult(true);
  }

  async getResult(isCanadian: boolean) {
    this.initialSearchModel.IsCanadian = isCanadian;
    const result = await searchAgents(this.searchModel);
    //Force search grid destroy
    this.travelAgents = null;
    Vue.nextTick(() => {
      this.travelAgents = result.Agents.map<SearchResultTravelAgent>((a) => ({
        Id: `${a.Agency}-${a.Agent}`,
        Category: { Text: a.Agency, Value: a.Agency },
        Title: a.Agent,
        Address: a.Address,
        Fax: a.Fax,
        Phone: a.Phone,
        Email: a.Email,
        Website: a.Website,
        Image: null,
        Link: { Link: '', Title: '' },
      }));
    });
  }

  created() {
    this.$on('submit', () => {
      this.searchAgent();
    });
  }
  mounted() {
    // @ts-ignore
    fixDropdownAudioEye(this.radius.$el, this.p.Radiuses.slice(0, 2), false)
  }
  fixUlOnClose() {
    setTimeout(() => {
      // @ts-ignore
      fixDropdownAudioEye(this.radius.$el, this.p.Radiuses.slice(0, 2), false)
    }, 500);
  }
}
